import { useId, useState } from 'react';
import { Button } from '@tervior-tech/tervior-shared-ui-react';
import { Label } from './Label';

interface CopyFieldProps {
  label: string;
  value: string;
}

/** Read-only field + copy button for a secret shown exactly once (API key reveal, Tela 5). */
export function CopyField({ label, value }: CopyFieldProps) {
  const id = useId();
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API unavailable (permissions, insecure context) — the
      // value is still visible and selectable in the input below.
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id}>{label}</Label>
      <div className="flex flex-col gap-2 sm:flex-row">
        <input
          id={id}
          readOnly
          value={value}
          onFocus={(event) => event.currentTarget.select()}
          className="w-full flex-1 rounded-none border border-input bg-muted/30 px-3 py-2 font-mono text-sm text-foreground"
        />
        <Button type="button" variant="outline" onClick={handleCopy} aria-live="polite" className="shrink-0">
          {copied ? 'Copiado!' : 'Copiar'}
        </Button>
      </div>
    </div>
  );
}
